import { render, staticRenderFns } from "./filter-tag.vue?vue&type=template&id=55fd8e22&scoped=true&"
import script from "./filter-tag.vue?vue&type=script&lang=js&"
export * from "./filter-tag.vue?vue&type=script&lang=js&"
import style0 from "./filter-tag.vue?vue&type=style&index=0&id=55fd8e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd8e22",
  null
  
)

export default component.exports